import React from 'react';
import { PlusOutlined, EditOutlined, CheckOutlined } from '@ant-design/icons';

const PLANS = [
  {
    name: 'Kids Plan', price: '₹800', period: '/month',
    color: '#00b4d8', bg: 'rgba(0,180,216,0.08)',
    members: 64,
    features: [
      'Kids Pool Only (Supervised)',
      'Weekdays 9 AM – 5 PM',
      'Floatation aids included',
      'Parent access to poolside',
    ],
  },
  {
    name: 'Standard', price: '₹1,500', period: '/month',
    color: '#0077b6', bg: 'rgba(0,119,182,0.08)',
    members: 112, popular: true,
    features: [
      'All Pools Access',
      'Flexible timing (6 AM – 10 PM)',
      '1 Coach Session per month',
      'Locker room access',
    ],
  },
  {
    name: 'Premium', price: '₹2,500', period: '/month',
    color: '#03045e', bg: 'rgba(3,4,94,0.06)',
    members: 72,
    features: [
      'All Pools 24/7 Access',
      'Unlimited Coaching Sessions',
      'Private locker & towel service',
      'Guest passes (2/month)',
      'Priority lane reservation',
    ],
  },
];

export default function Plans() {
  return (
    <div>
      <div className="page-header">
        <div><h2>Membership Plans</h2><p>Configure and manage subscription tiers</p></div>
        <button className="btn-aqua"><PlusOutlined /> Add Plan</button>
      </div>

      <div className="row g-4 mb-4">
        {PLANS.map(p => (
          <div className="col-12 col-md-4" key={p.name}>
            <div className="plan-card" style={{ position: 'relative' }}>
              {p.popular && (
                <div style={{
                  position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)',
                  background: 'linear-gradient(135deg,var(--primary),var(--accent))',
                  color: '#fff', fontSize: 11, fontWeight: 700,
                  padding: '4px 14px', borderRadius: 20, whiteSpace: 'nowrap',
                }}>⭐ Most Popular</div>
              )}
              {/* Accent bar */}
              <div style={{ height: 5, borderRadius: 4, background: p.color, marginBottom: 20 }} />

              <div style={{ fontFamily: "'Exo 2',sans-serif", fontSize: 20, fontWeight: 800, color: 'var(--deep)', marginBottom: 6 }}>{p.name}</div>

              <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 6 }}>
                <span style={{ fontSize: 30, fontWeight: 800, color: p.color }}>{p.price}</span>
                <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>{p.period}</span>
              </div>

              <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 18 }}>
                Currently <strong style={{ color: 'var(--deep)' }}>{p.members} members</strong> enrolled
              </div>

              <div style={{ borderTop: '1px solid var(--border)', paddingTop: 16 }}>
                {p.features.map(f => (
                  <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 9, fontSize: 13, color: 'var(--text)' }}>
                    <span style={{ color: p.color, fontWeight: 700, fontSize: 12 }}><CheckOutlined /></span>
                    {f}
                  </div>
                ))}
              </div>

              <div style={{ display: 'flex', gap: 8, marginTop: 20 }}>
                <button className="btn-aqua" style={{ flex: 1, justifyContent: 'center', background: `linear-gradient(135deg,${p.color},var(--accent))` }}>
                  <EditOutlined /> Edit Plan
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Summary table */}
      <div className="aq-card">
        <div className="aq-card-header"><h5 className="aq-card-title">Plan Summary</h5></div>
        <div className="aq-table-wrap">
          <table className="aq-table">
            <thead><tr><th>Plan</th><th>Monthly Fee</th><th>Members</th><th>Revenue</th><th>Status</th></tr></thead>
            <tbody>
              {PLANS.map(p => (
                <tr key={p.name}>
                  <td style={{ fontWeight: 600 }}>{p.name}</td>
                  <td style={{ fontWeight: 700, color: 'var(--deep)' }}>{p.price}</td>
                  <td>{p.members}</td>
                  <td style={{ fontWeight: 700, color: '#10b981' }}>
                    ₹{(parseInt(p.price.replace('₹','').replace(',','')) * p.members).toLocaleString('en-IN')}
                  </td>
                  <td><span className="badge badge-success">Active</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
